module.exports = __webpack_public_path__ + "img/record_review.2c557c94.svg";